const docTypes:Record<string, number>={
    pdf : 1,
    docx : 2,
    xls : 3,
    xlsx : 4,
    ppt : 5,
    pptx : 6,
    doc : 7,
    txt : 8,
    png : 9,
    jpg : 10,
    jpeg : 11,
    csv : 12,
}
export const getDocType = (fileName:string) => {
  const extension = fileName.split(".").pop()?.toLowerCase() ?? ""
  return docTypes[extension]
}